<template>
  <s-wrapper class="app-spinner" :variant="variant" :size="size" />
</template>

<script>
import { AppSpinnerProps, SWrapper } from "./styles";

export default {
  name: "AppSpinner",
  components: {
    SWrapper
  },
  props: AppSpinnerProps
};
</script>
